<div style="display:flex; flex:1 0 auto; flex-direction:column; height:100%">
  <div class="form-header">
    <div *ngIf="account.parentId == undefined" class="form-title">
      Users added to this account have access to all companies, assessments and account settings management.
    </div>
    <div *ngIf="account.parentId != undefined" class="form-title">
      Users added to this account only have access to assessments and account settings for this account.
    </div>  
    <button [disabled]="selectedUser || (!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM'))" mat-raised-button color="primary" style="flex-shrink:0" (click)="newUser()">Add New User</button>
  </div>

  <div class="form-headernotification" *ngIf="(!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM'))">
    Your role does not allow for saving settings changes on this screen.
  </div>
  <div class="user-screen">
    <ng-container *ngIf="selectedUser">
      <form class="form-field-list" [formGroup]="form">
        <div>
          <mat-form-field>
              <input matInput placeholder="First Name" formControlName="firstName" required>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <input matInput placeholder="Last Name" formControlName="lastName" required>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <input matInput placeholder="Email Address" formControlName="email" required email>
            <mat-error *ngIf="form.controls.email?.errors?.email">Invalid email address</mat-error>
            <mat-error *ngIf="form.controls.email?.errors?.inUse">This email is associated with another user</mat-error>
          </mat-form-field>
        </div>
        <div class="credentials-rows">
          <mat-checkbox [disabled]="selectedUser.directEnabled" [matTooltip]="selectedUser.directEnabled ? 'Direct access cannot be disabled' : 'Allow the user to login directly through the main login form.'" formControlName="directEnabled">Direct Access</mat-checkbox>
          <mat-checkbox *ngIf="form.controls.directEnabled.value" [matTooltip]="form.controls.directMfaEnabled.value ? 'The user has MFA enabled. Turning this off will allow them to login without using MFA.' : 'The user has to turn on MFA on their own'" formControlName="directMfaEnabled">MFA Enabled</mat-checkbox>
        </div>
        <div class="credentials-rows">
          <mat-checkbox [disabled]="true" matTooltip="Users need to manage their ConnectWise SSO access on their own." formControlName="ssoEnabled">SSO Access</mat-checkbox>
        </div>
        <div class="credentials-rows" *ngIf="!account?.parentId && account?.manageIntegration?.isEnabled">
          <mat-checkbox matTooltip="Allow the user to connect to Identify using the Manage Integration." formControlName="manageEnabled" (click)="handleEvent({state:'MANAGE_INTEGRATION_CLICKED'})">Manage Integration Access</mat-checkbox>
          <mat-form-field *ngIf="form.controls.manageEnabled.value">
            <input type="text" matInput placeholder="Manage User" formControlName="manageUserDropdown" [matAutocomplete]="users.auto" (blur)="forbiddenNames(form.controls.manageUserDropdown)">
            <cw-manage-user-dropdown #users (eventHandler)="handleEvent($event)" [partnerAccount]="account" [disableInUseUsers]="true" [searchControl]="form.controls.manageUserDropdown"></cw-manage-user-dropdown>
            <mat-error *ngIf="form.controls.manageUserDropdown?.hasError('incorrect')">Please select a value from the dropdown</mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="selectedUser.id && selectedUser.id != sessionService.getCurrentUser().id" class="button-wrapper">
          <button *ngIf="sessionService.isAccountType('SYSTEM')" [disabled]="!sessionService.hasRole(RoleType.ADMIN)" mat-raised-button type="button" color="primary" svgIcon="cw:resend_email" (click)="resendInvitation(selectedUser)">Resend Invite</button>
          <button mat-raised-button type="button" [disabled]="disableDelete" color="primary" (click)="deleteUser(selectedUser)">Delete</button>
        </div>
      </form>
    </ng-container>
    
    <cw-ci-data-table #userDataTable *ngIf="!selectedUser"
      tileTitle="Users Added"
      addToolTip="Create a new user"
      refreshToolTip="Reload user list"
      defaultSortField="first_name"
      hidePageSize="true"
      hideRefreshButton="true"
      hideWrapper="true"
      pageSize="8"
      skipInitialLoad="true"
      [isSelectable]="isSelectable"
      (loadItemsHandler)="loadUsers($event)"
      (addHandler)="newUser($event)"
      (selectHandler)="selectUser($event)"
      [items]="userList"
      class="users-multiline">

      <cw-ci-table-column columnName="firstName" columnTitle="First Name" sortField="first_name" maxWidth="100px"></cw-ci-table-column>
      <cw-ci-table-column columnName="lastName" columnTitle="Last Name" sortField="last_name" maxWidth="100px"></cw-ci-table-column>
      <cw-ci-table-column columnName="email" columnTitle="Email" sortField="email" maxWidth="150px"></cw-ci-table-column>
      <cw-ci-table-column columnName="directEnabled" columnTitle="Direct" [output]="directEnabledTemplate" filterType="select" [filterOptions]="[{display:'Yes', value:'true'}, {display:'No', value:'false'}]"></cw-ci-table-column>
      <ng-template let-element #directEnabledTemplate><mat-icon color="accent" *ngIf="element.directEnabled">check</mat-icon></ng-template>
      <cw-ci-table-column columnName="ssoEnabled" columnTitle="SSO" [output]="ssoEnabledTemplate" filterType="select" [filterOptions]="[{display:'Yes', value:'true'}, {display:'No', value:'false'}]"></cw-ci-table-column>
      <ng-template let-element #ssoEnabledTemplate><mat-icon color="accent" *ngIf="element.ssoEnabled">check</mat-icon></ng-template>
      <ng-container *ngIf="!account?.parentId && account?.manageIntegration?.isEnabled">
        <cw-ci-table-column columnName="manageEnabled" columnTitle="Manage" [output]="manageEnabledTemplate" filterType="select" [filterOptions]="[{display:'Yes', value:'true'}, {display:'No', value:'false'}]"></cw-ci-table-column>
        <ng-template let-element #manageEnabledTemplate><mat-icon color="accent" *ngIf="element.manageEnabled">check</mat-icon></ng-template>
      </ng-container>

      <cw-ci-table-column columnName="actions" [output]="actionTemplate"></cw-ci-table-column>
      <ng-template let-element #actionTemplate>
        <cw-ci-table-column-action actionToolTip="Edit the user" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="selectUser($event)"></cw-ci-table-column-action>
      </ng-template>
    </cw-ci-data-table>

  </div>
</div>